import { Stack } from 'react-bootstrap'
import { Link } from 'react-router-dom';

export const IdTableCellLink = (rowProps) => {
    
    const { value, data, gridRef } = rowProps;
    
    let path = rowProps.path
    if(rowProps.data !== undefined)
    {
        path = path.concat(rowProps.data.id);
    }
    
    return (
        rowProps.data === undefined? <div></div>  : 
        <>
        <Stack direction="horizontal" gap={2}>
            <Link to={path} className="blue-link">{rowProps.data.id}</Link>
            </Stack>
        </>   
    )
};

export const NameTableCellLink = (rowProps) => {
    
    const { value, data, gridRef } = rowProps;
    
    let path = rowProps.path
    if(rowProps.data !== undefined)
    {
        path = path.concat(rowProps.data.id);
    }
    
    return (
        rowProps.data === undefined? <div></div>  : 
        <>
        <Stack direction="horizontal" gap={2}>
            <Link to={path} className="blue-link">{rowProps.data.fileName}</Link>
            </Stack>
        </>   
    )
};






